namespace GeniuzPOS.Purchase {
    export interface LookupPIforIrRow {
        SysDocNo?: string;
        SupplierId?: string;
    }

    export namespace LookupPIforIrRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.LookupPIforIr';
        export const lookupKey = 'Purchase.LookupPIforIr';

        export function getLookup(): Q.Lookup<LookupPIforIrRow> {
            return Q.getLookup<LookupPIforIrRow>('Purchase.LookupPIforIr');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            SysDocNo = "SysDocNo",
            SupplierId = "SupplierId"
        }
    }
}
